<style lang="scss">
    .beat-license-container {
        border: 1px solid #e6e6e6;
        border-radius: 5px;
        text-align: center;
        display: inline-block;
        flex-direction: column;
        justify-content: space-between;
        transition: transform .2s;
        padding: 15px 5px 0px 5px;
        background: #ffffff;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
        color: #595E63;
        .best-offer{
            font-size: 13px;
            font-weight: 600;
            margin-bottom: 0;
            &.no-price {
                font-size: 24px;
                margin-top: 12px;
                margin-bottom: 16px;
            }
        }
        .license-container{
            cursor: pointer;
            min-height: 170px;
        }
        .license-cart {
            font-size: 16px;
            margin-bottom: 0.5rem;
            color: white;
        }
        .license-name {
            font-size: 14px;
            font-weight: 600;
            text-transform: uppercase;
        }
        .license-terms-title {
            font-size: 12px;
        }
        .price{
            color: #e15498;
            font-family: Poppins;
            font-size: 30px;
            font-weight: 600;
            text-align: center;
            margin: 10px 0 10px;
        }
        .offer {
            font-size: 20px;
        }
        .file-type-wrapper {
            font-size: 13px;
            margin-bottom: 10px;
            .file-type-title {
                font-weight: 600;
            }
        }
        .buy-button {
            background-color: #e15498;
            color: #ffffff;
            position: relative;
            width: calc(100% + 12px);
            left: -6px;
            bottom: -1px;
            border-radius: 0 0 4px 4px;
            font-size: 14px;
            cursor: pointer;
            border-top: 1px solid rgba(0, 0, 0, 0.07) !important;

            .discount-icon-wrapper{
                height: 100%;
                width: 25%;
                padding: 10px 8px 6px 8px;
                border-left: 1px solid rgba(0,0,0,0.07);
                .fa-chevron-down, .fa-chevron-up {
                    font-size: .6rem;
                    transform: translate(3px,-4px);
                }
            }  

            .license-terms-wrapper{
                padding: 10px 0;
            }

            .full-wrapper{
                width: 75% !important;
            }
        }

        &.incart{
            background-image: linear-gradient(143deg, #ff5b94 0%, #8441a4 100%);
            border: none;
            .license-name {
                color: #ffffff;
            }
            .license-terms-title {
                color: #ffffff;
            }
            .price{
                color: #ffffff !important;
            }
            .file-type-wrapper{
                color: #ffffff;
            }
            .discount-icon-wrapper{
                color: #ffffff;
            }
            .buy-button {
                width: calc(100% + 10px);
                left: -5px;
            }
        }
    }

    .beat-license-container:hover{
        border: 1px solid #e15498;
        transform: scale(1.05);
        .buy-button, .discounts-box {
            width: calc(100% + 10px);
            left: -5px;
        }
    }

    .flex-wrapper{
        padding: 0px 0 !important;
        display: flex;
    }
    .discounts-box {
        position: relative;
        width: calc(100% + 12px);
        margin-top: -1px;
        left: -6px;
        bottom: 0px;
        border-radius: 0px 0px 5px 5px;
        font-size: 12px;
        cursor: pointer;
        padding: 10px 10px;
        background: rgb(186, 62, 122);
        color: rgb(255, 255, 255);

        .row {
            margin: 0;
        }

        .discount-quantity {
            float: left;
            padding-left: 10px;
        }
        .discount-price {
            float: right;
        }
    }
    .collapsing {
       position: relative;
        height: 0;
        overflow: hidden;
        transition-timing-function: ease;
        transition-duration: .1s;
        transition-property: height;
    }

</style>

<template>
    <div class="beat-license-container" :class="{'incart' : beat.inCart(price.license)}" :style="$beatLicenseStyle(beat.inCart(price.license))">
        <div class="license-container" @click="buy">
            <div>
                <div class="license-cart" :style="{'color': $licenseDiscountsButtonStyle(!beat.inCart(price.license)).color}"><font-awesome-icon :icon="beat.inCart(price.license) ? 'shopping-cart' : 'cart-plus'"></font-awesome-icon></div>
                <div class="license-name" v-once>{{price.license.name}}</div>
            </div>

            <template v-if="price.license.isAllowedOffers()">
                    <div class="price" :style="$beatLicensePriceStyle">
                        <div v-if="price.isSaleable()">{{ price.price | displayPrice }}</div>
                        <div class="offer" v-if="!beat.inCart(price.license)">
                            <p class="best-offer" :class="{'no-price' : !price.isSaleable()}"><span v-if="price.isSaleable()">OR</span> BEST OFFER</p>
                        </div>
                    </div>

            </template>
            <template v-else>

                    <div class="price" v-if="price.isSaleable()" :style="$beatLicensePriceStyle">
                        <div>{{ price.price | displayPrice }}</div>
                    </div>

            </template>

            <div class="file-type-wrapper">
                <div class="file-type-title">Files available</div>
                <div>
                    <span> MP3</span><span v-if="price.license.wav">, WAV</span><span v-if="price.license.trackout">, Trackout</span>
                </div>
            </div>

        </div>

        <div class="buy-button" :class="{'flex-wrapper': price.hasDiscount()}" :style="$licenseDiscountsButtonStyle(false)">
            <div class="license-terms-wrapper" :class="{'full-wrapper': price.hasDiscount()}" @click="setModalLicense(price.license.id)">
                <span class="license-icon">License Terms</span>
            </div>
            <div class="discount-icon-wrapper" v-if="price.hasDiscount()" @click.stop="toggleDiscounts()">
                <svg :style="discountIconColor(false)" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="19" viewBox="0 0 12 19"><defs><path id="b4qqa" d="M1258.94 20a.6.6 0 0 0-.6.6v4.74a.6.6 0 0 0 1.2 0V20.6a.6.6 0 0 0-.6-.59z"/><path id="b4qqb" d="M1260.13 34.85a.6.6 0 1 1 1.18 0 .6.6 0 0 1-1.18 0z"/><path id="b4qqc" d="M1256.56 30.1a.6.6 0 1 1 1.2 0 .6.6 0 0 1-1.2 0z"/><path id="b4qqd" d="M1260.72 36.63a1.78 1.78 0 1 1 0-3.57 1.78 1.78 0 0 1 0 3.57zm-4.75 0a.6.6 0 0 1-.46-.98l5.94-7.12a.6.6 0 0 1 .91.76l-5.94 7.13a.6.6 0 0 1-.45.2zm1.19-8.32a1.78 1.78 0 1 1 0 3.57 1.78 1.78 0 0 1 0-3.57zm4.4-5.93h-.84v2.96a1.78 1.78 0 0 1-3.56 0v-2.96h-.84l-3.32 3.31v12.13c0 .65.53 1.18 1.19 1.18h9.5c.66 0 1.19-.53 1.19-1.18V25.69z"/></defs><g><g transform="translate(-1253 -20)"><g><g><g><use xlink:href="#b4qqa"/></g></g></g><g><g><g><use xlink:href="#b4qqb"/></g></g></g><g><g><g><use xlink:href="#b4qqc"/></g></g></g><g><g><g><use xlink:href="#b4qqd"/></g></g></g></g></g></svg>
                
                <svg v-show="!activeCollapse" :style="discountIconColor(false)" class="svg-inline--fa fa-chevron-down fa-w-14" aria-hidden="true" data-prefix="fal" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z"></path></svg>
                <svg v-show="activeCollapse" :style="discountIconColor(false)" class="svg-inline--fa fa-chevron-up fa-w-14" style="color: rgb(255, 255, 255); fill: rgb(255, 255, 255); display: none;" aria-hidden="true" data-prefix="fa" data-icon="chevron-up" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"></path></svg>
            </div>
        </div>
        <div :id="collapseId" class="discounts-box collapse" :style="$beatLicenseStyle(beat.inCart(price.license))">
            <div class="row" :key="index" v-for="(discount, index) in price.license.discounts">
                <span class="discount-quantity">{{discount.quantity}} Beats</span>
                <span class="discount-price">${{discount.price}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import Configure from './../../mixins/configure'

    export default {
        props: {
            price: Object,
            beat: Object,
            collapseId: ''
        },
        computed: {
            offerModal() {
                return this.$store.state.offerModal
            },
            licenses() {
                return this.$store.getters.licenses;
            },
            activeCollapse() {
                if (this.$store.state.activePackageDiscount == this.collapseId) {
                    return true
                }
                return false
            }
        },
        mixins: [Configure],
        methods: {
            hover(isHovering) {
                this.$data.$hover.beatLicense = isHovering
            },
            buy() {
                if (this.price.license.isAllowedOffers() && !this.beat.inCart(this.price.license)) {
                    if (this.offerModal) {
                        this.$store.commit("offerable", {offerable: {
                                beat: this.beat,
                                price: this.price.license
                            }})

                        this.offerModal.modal('show')
                    }
                } else {
                    this.beat.addToCart(this.price.license)
                    this.$emit('license-added')
                }
            },
            setModalLicense(licenseId) {

                for (var i = 0; i < this.licenses.length; i++) {
                    if (this.licenses[i].id == licenseId) {
                        this.$store.commit('modalLicense', {modalLicense : this.licenses[i]});
                        $('#license-terms').modal('show')
                    }
                }
            },
            discountIconColor(active) {
                return {
                    color: this.$licenseDiscountsButtonStyle(active).color,
                    fill: this.$licenseDiscountsButtonStyle(active).color
                }
            },
            toggleDiscounts() {
                $('#' + this.collapseId).collapse('show')
                $('.collapse.in').collapse('hide')

                if (!this.activeCollapse) {
                    this.$store.commit('activeDiscountCollapse', this.collapseId)
                } else {
                    this.$store.commit('activeDiscountCollapse', null)
                }
            }
        }
    }
</script>
